import { render, staticRenderFns } from "./MarketItem.vue?vue&type=template&id=43943387&scoped=true&"
import script from "./MarketItem.vue?vue&type=script&lang=js&"
export * from "./MarketItem.vue?vue&type=script&lang=js&"
import style0 from "./MarketItem.vue?vue&type=style&index=0&id=43943387&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43943387",
  null
  
)

export default component.exports